import { useEffect, useState } from "react";
import { api } from "../api.js";

// Банк за IBAN з довідника банків НБУ (/api/banks/by-iban). Повний IBAN UA + 27 цифр → { name, mfo, … } або null.
// Відповіді кешуються на сесію: МФО в межах сторінки повторюються
const cache = new Map();
export function lookupBank(iban) {
  const s = String(iban || "").replace(/\s/g, "").toUpperCase();
  if (!/^UA\d{27}$/.test(s)) return Promise.resolve(null);
  const mfo = s.slice(4, 10);
  if (!cache.has(mfo)) cache.set(mfo, api(`/api/banks/by-iban?iban=${s}`).then((r) => r.bank, () => null));
  return cache.get(mfo);
}

// onFound(bank) — коли банк знайдено для поточного IBAN (наприклад, підставити в порожнє поле «Банк»)
export function useBank(iban, onFound) {
  const [bank, setBank] = useState(null);
  useEffect(() => {
    let live = true;
    setBank(null);
    lookupBank(iban).then((b) => { if (!live) return; setBank(b); if (b) onFound?.(b); });
    return () => { live = false; };
  }, [String(iban || "").replace(/\s/g, "").toUpperCase()]); // eslint-disable-line react-hooks/exhaustive-deps
  return bank;
}
